import styled, {css} from "styled-components";
import {getColorFromTheme} from "../../utils/style.utils";
import {IconPositionType, RoundedType, SizeType} from "./button.component";

export interface ButtonStyleProps {
    $type?: "filled" | "outlined" | "text";
    $color?: string;
    $borderColor?: string;
    $bgColor?: string;
    $size?: SizeType;
    $fullWidth?: boolean;
    $iconPosition?: IconPositionType;
    $rounded?: RoundedType
}

export const ButtonWrapper = styled.button<ButtonStyleProps>`
    background: transparent;
    color: ${({$color}) => $color || getColorFromTheme("white")};
    border: ${({$type, $color}) =>
            $type === "outlined" ? `1px solid ${$color || getColorFromTheme("neutral400")}` : "none"};
    padding: ${({$size}) =>
            $size === "small" ? "0.5rem 0.75rem" : $size === "large" ? "20px 16px" : "16px 15px"};
    font-size: ${({$size}) =>
            $size === "small" ? "calc(var(--step-0)*0.87)" : $size === "large" ? "var(--step--1)" : "calc(var(--step-0)*0.86)"};
    background: ${({$bgColor, $type}) =>
            $type === "filled"
                    ? $bgColor || getColorFromTheme("secondaryDark")
                    : "transparent"};
    font-family: SpaceGrotesk;
    width: ${({$fullWidth}) => $fullWidth ? "100%" : "initial"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 0.5rem;
    flex-wrap: nowrap;
    font-weight: 500;
    letter-spacing: 0%;
    place-items: center;
    transition: background 0.2s ease-in-out;
    flex-wrap: nowrap;
    text-wrap: nowrap;
    max-width: ${({$fullWidth}) => $fullWidth ? "100%" : "max-content"};

    &:hover {
        background: ${({$bgColor, $type}) =>
                $type === "filled"
                        ? $bgColor || "#17053d"
                        : "transparent"};
    }

    .icon {
        margin-inline: ${({$iconPosition}) => $iconPosition === "start" ? "0px 6px" : "6px 0px"};
        width: 1em;
        height: 1em;
        font-size: ${({$size}) =>
                $size === "small" ? "1em" : $size === "large" ? "2em" : "1.5em"};
    }

    &:disabled, &:hover:disabled {
        background: ${getColorFromTheme("neutral300")} !important;
        color: var(--color-border) !important;;
        cursor: not-allowed !important;
        border: none !important;

        [data-theme="dark"] & {
            background: color-mix(in srgb, var(--color-border) 60%, transparent) !important;
        }
    }

    ${(props) => {
        return props.$type === "filled" ? css`
                    &:hover {
                        background: ${props.$bgColor || "#17053d"};
                    }
                ` :
                props.$type === "outlined" ? css`
                    background: transparent;
                    border: 1px solid ${props.$borderColor || "#D0D5DD"};
                    color: ${props.$color || "var(--color-text)"};
                ` : css`
                    color: ${props.$color || "var(--color-text)"};
                `
    }}
`;
